import { useAppSelector } from '../../redux';
import CurrentMarker from '../CurrentMarker';
import DrawControlsProvider from './DrawControls/DrawControlsProvider';
import Segments from './Segments/Segments';
import Waypoints from './Waypoints';
import useMetadata from './useMetadata';

type CustomRouteProps = {
  canEdit?: boolean;
  trackUserInteractions?: () => void;
};

const CustomRoute = ({ canEdit = false, trackUserInteractions }: CustomRouteProps) => {
  const elevationCoordinates = useAppSelector(state => state.map.elevationCoordinates);

  useMetadata({ autoUpdate: true, trackUserInteractions });

  return (
    <DrawControlsProvider>
      {elevationCoordinates && <CurrentMarker latitude={elevationCoordinates.lat} longitude={elevationCoordinates.lng} />}
      <Segments />
      <Waypoints canEdit={canEdit} />
    </DrawControlsProvider>
  );
};

export default CustomRoute;
